module.exports = __webpack_public_path__ + "img/google.92ed12de.svg";